export default __webpack_public_path__ + "static/sixt-rash-a317b9ae0286f1c05de78c61c0686929.png";